module.exports = __webpack_public_path__ + "media/applications/components/HeaderApp/assets/menu-8c6c2d7e86425c559563c3c1783619d2.svg";